import { ChangeDetectionStrategy, Component, HostBinding, OnInit, ViewEncapsulation } from "@angular/core";
import { SiteAppCommand, SiteAppAppValue } from "@fabric-types/app-site";
import { BlogPost } from "@obg/ngx.common";
import { DeviceConfigService, DeviceType } from "@obg/ngx.global";
import { DocumentRef } from "@obg/ngx.global.evo";
import { Observable } from "rxjs";
import { filter, take } from "rxjs/operators";

const MAX_POSTS = 3;

@Component({
	selector: "obg-rss-feed",
	templateUrl: "./rss-feed.container.html",
	styleUrls: ["./rss-feed.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class RssFeedContainer implements OnInit {
	@HostBinding("class.obg-rss-feed") hostCssClass = true;

	isMobile = false;
	maxPosts = MAX_POSTS;
	placeholders = Array(MAX_POSTS);

	feed$: Observable<BlogPost[] | undefined> | undefined;

	constructor(
		private deviceConfigService: DeviceConfigService,
		private documentRef: DocumentRef
	) {}

	ngOnInit() {
		this.documentRef.obgEventBus?.dispatch(SiteAppCommand.GetAllBlogPosts);

		this.feed$ = new Observable(this.documentRef.obgEventBus.retrieve(SiteAppAppValue.BlogPosts)).pipe(
			take(1),
			filter((feed) => !!feed?.length)
		);

		this.isMobile = this.deviceConfigService.getPlatform() !== DeviceType.Desktop;
	}

	trackByPost(_index: number, post: BlogPost): number {
		return post.id;
	}
}
